import { cn } from '@/platform/lib/utils';

// Stacks full-width on mobile with the last (primary) action on top, and turns
// into a right-aligned row from sm upwards.
const ModalActions = ({ className, children, ...props }) => (
    <div
        className={cn(
            'flex flex-col-reverse gap-2 sm:flex-row sm:justify-end',
            className
        )}
        {...props}
    >
        {children}
    </div>
);

export default ModalActions;
